<template>
  <v-layout>
    <v-flex xs12 sm8 md9>
      <p class="service-name">{{service.name}}</p>
    </v-flex>

    <v-flex xs12 sm4 md3>
      <p class="service-amount">
        <template v-if="hasServices">({{service.quantity}})</template>
        {{currency(service.subtotal)}}
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { CurrencyFilter } = Mixins;

export default {
  mixins: [CurrencyFilter],
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasServices() {
      return this.service.quantity > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.service-name {
  line-height: 1.5;
}

.service-amount {
  line-height: 1.5;
  text-align: right;
}
</style>
